import {call, put} from 'redux-saga/effects';
import FirmwaresActions from '../redux/FirmwaresRedux';
import MessagesActions from '../redux/MessagesRedux';

export function * getFirmwares(api, action) {
  const response = yield call(api.getFirmwares, {...action.props});

  if (response.ok) {
    yield put(FirmwaresActions.firmwaresSuccess({...response.data, ...action.props}));
  } else {
    yield put(FirmwaresActions.firmwaresFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}
